
import { BaseService } from "../../BaseService";

export interface IProfile {
    email: string;
    phone: string;
    last_name: string;
    first_name: string;
    other_names: string;
    external_id: string;
    profile_picture_location: string;
}

export class LanuariusBaseService extends BaseService {

    constructor() {
        super(process.env.REACT_APP_LANUARIUS_BASE_API_URL ?? "http://127.0.0.1:9001");
    }

}
